import script from "./SimCardStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimCardStats.vue?vue&type=script&setup=true&lang=ts"

import "./SimCardStats.vue?vue&type=style&index=0&id=0826a8a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0826a8a7"]])

export default __exports__